import { useEffect, useRef } from 'react'
import { X } from 'lucide-react'
import { brandLogo } from '@/components/navigation/navigationAssets'

const editorialLinks = [
  { label: 'Última hora', href: 'https://www.eltelegrafo.com.ec/ultima-hora' },
  { label: 'Nacionales', href: 'https://www.eltelegrafo.com.ec/nacionales' },
  { label: 'Internacionales', href: 'https://www.eltelegrafo.com.ec/internacionales' },
  { label: 'Deportes', href: 'https://www.eltelegrafo.com.ec/deportes' },
  { label: 'Tendencias', href: 'https://www.eltelegrafo.com.ec/tendencias' },
  { label: 'Especiales', href: 'https://www.eltelegrafo.com.ec/especiales-et' },
  { label: 'Opinión', href: 'https://www.eltelegrafo.com.ec/opinion' },
] as const

interface MobileMenuOverlayProps {
  isOpen: boolean
  onClose: () => void
}

export function MobileMenuOverlay({ isOpen, onClose }: MobileMenuOverlayProps) {
  const closeButtonRef = useRef<HTMLButtonElement>(null)

  useEffect(() => {
    if (!isOpen) return

    closeButtonRef.current?.focus()

    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose()
    }

    document.body.classList.add('has-mobile-menu')
    window.addEventListener('keydown', handleKeyDown)

    return () => {
      document.body.classList.remove('has-mobile-menu')
      window.removeEventListener('keydown', handleKeyDown)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  return (
    <div className="mobile-menu" role="dialog" aria-modal="true" aria-label="Menú principal">
      <div className="mobile-menu__panel">
        <div className="mobile-menu__top">
          <img src={brandLogo} alt="El Telegrafo" />
          <button
            ref={closeButtonRef}
            type="button"
            className="icon-button"
            onClick={onClose}
            aria-label="Cerrar menú"
          >
            <X size={24} strokeWidth={3} aria-hidden="true" />
          </button>
        </div>

        <nav className="mobile-menu__nav" aria-label="Secciones de El Telégrafo">
          {editorialLinks.map((link) => (
            <a key={link.href} href={link.href} className="mobile-menu__link" onClick={onClose}>
              <strong>{link.label}</strong>
              <b aria-hidden="true">{'>'}</b>
            </a>
          ))}
        </nav>
      </div>
    </div>
  )
}
